export default async function (state, appOptions) {
  const Webex = (await import(/* webpackChunkName: 'app-viz' */ '../../apps/webex/index')).default
  return document.createElement(Webex.tagName)
}
